/**
 * All the stored procedures that are used by the project are stored here
 */
import { getProxyUrl } from "./serverEnvironmentConfig";

const proxyUrl = getProxyUrl();

const ax = require("axios");

function showError(msg) {
	console.log(msg);
}

const catchError = (error, component) => {
	let er = "Error loading " + component + ": " + error;
	console.log(er);
};

const storedProcedure = {
	getPackages: {
		url: proxyUrl,
		requestObject: ({ inv, sites }) => ({
			type: "json",
			method: "dbo.Web_getPackageInfoFromView",
			classname: "DbTbOnline",
			params: { inv, sites },
		}),
	},
	getCompletedOrder: {
		url: proxyUrl,
		requestObject: (hash) => ({
			type: "json",
			method: "dbo.GetSinglePackageOrder_2025",
			classname: "DbDsWeb",
			params: { MD5: hash },
		}),
	},
	getSchoolFromOrgID: {
		url: proxyUrl,
		requestObject: (OrgID) => ({
			type: "json",
			method: "DSDB.getSchoolFromOrgID",
			classname: "DbDsContacts",
			params: { OrgID },
		}),
	},
};

const getAllLiveProducts = (callback) => {
	const result = ax.create({
		withCredentials: true,
	});

	result
		.post(proxyUrl, {
			type: "json",
			method: "getAllLiveProducts",
			classname: "DbTbOnline",
		})
		.then((data) => {
			if (data.data.error) {
				console.log(data.data);
				console.error(data.data.error.errortext);
				return;
			}

			callback(data.data);
		})
		.catch(function (error) {
			catchError(error, "suite assignments", showError);
		});
};

export { storedProcedure, getAllLiveProducts };
